import { LocaleEnum } from '@systemeio/ui'

export const getLocaleForLink = (locale?: LocaleEnum) => {
  switch (locale) {
    case LocaleEnum.ENGLISH:
      return '/'
    case LocaleEnum.TURKISH:
      return '/tur'
    default:
      return `/${locale}`
  }
}
